/**
 * Bot-Schutz fuer alle Newsletter-Formulare des Themes.
 *
 * Hintergrund, am Bestand gemessen (26.08.2026): 984 Kunden stehen auf PENDING,
 * taeglich kommen 5 bis 18 dazu, aber nur rund 8 pro Monat bestaetigen. Die
 * unbestaetigte Gruppe hat zu 77 Prozent keinen Namen und zu 99 Prozent nie
 * bestellt, ihre Domains sind anglophon (yahoo, aol, comcast) statt deutsch
 * (gmx, web, t-online), darunter Adressen wie ncsc.nl achtmal. Das sind
 * Automaten auf den Formularen, keine unzufriedene Kundschaft.
 *
 * Zwei Signale, beide mit sehr geringer Fehlerquote gegen echte Anmelder:
 *
 *   1. Das Koederfeld gw_website ist ausgefuellt. Menschen sehen es nicht,
 *      erreichen es nicht per Tab und Screenreader ueberspringen es.
 *   2. Im Formular hat nie eine Nutzereingabe stattgefunden. Ein Mensch
 *      fokussiert, tippt, klickt oder tippt auf den Bildschirm, bevor er
 *      abschickt. Ein Skript, das nur .value setzt und requestSubmit ruft,
 *      erzeugt keines dieser Ereignisse.
 *
 * Warum Signal 2 breit gefasst ist (focusin, input, keydown, click, touchstart):
 * eine engere Fassung wuerde einen echten Fall treffen. Nach einem
 * Validierungsfehler rendert Shopify die Adresse wieder ins Feld; wer dann nur
 * auf Absenden klickt, ohne das Feld anzufassen, loest kein input aus. Der
 * Klick auf den Knopf zaehlt deshalb mit.
 *
 * WARUM CAPTURE AM DOCUMENT, und warum stopImmediatePropagation:
 * Im Browser nachgemessen. Ein fremder submit-Listener auf demselben Formular
 * erzwingt die Absendung ueber eine vorab gesicherte Referenz auf
 * HTMLFormElement.prototype.submit. Der Aufruf taucht in keinem Monkey-Patch
 * auf, und ein blosses preventDefault in der Bubble-Phase bleibt wirkungslos:
 * das Formular postet trotz defaultPrevented === true (verifiziert daran, dass
 * updatedAt eines echten Testkunden sprang). Vermutlich Shopifys eigener
 * Spam-Schutz. Die Capture-Phase am document laeuft vor jedem Listener am
 * Formular, stopImmediatePropagation verhindert, dass der fremde ueberhaupt
 * dran kommt.
 *
 * Der Beleg fuer wen es nachpruefen will: derselbe Listener haelt in der
 * Capture-Phase und haelt nicht in der Bubble-Phase. Diese Asymmetrie ist nur
 * mit einem fremden erzwingenden Listener erklaerbar.
 *
 * Reichweite, damit niemand mehr erwartet: der Schutz greift bei Automaten, die
 * die Seite rendern und das Formular im DOM abschicken. Ein Skript, das direkt
 * auf Shopifys /contact postet, sieht weder Koeder noch Interaktion. Dagegen
 * hilft kein Theme-Code, sondern nur ein Schutz vor dem Endpunkt.
 */
(function () {
  'use strict';

  // Mehrfaches Einbinden ist erlaubt: vier Sections koennen dieselbe Datei
  // laden. Der Listener darf trotzdem nur einmal haengen, sonst sperrt der
  // zweite Durchlauf nach dem stopImmediatePropagation des ersten ins Leere.
  if (window.__gwNewsletterBotschutz) return;
  window.__gwNewsletterBotschutz = true;

  const KOEDER = '[name="gw_website"]';
  const MELDUNG = '[data-botschutz-meldung]';

  // WeakSet statt Attribut oder Datenfeld: aus dem Seitenkontext nicht
  // erreichbar. Ein Skript kann sich die Interaktion damit nicht selbst
  // ausstellen, indem es ein data-Attribut setzt.
  const interagiert = new WeakSet();

  const EREIGNISSE = ['focusin', 'input', 'keydown', 'click', 'touchstart'];

  function merkeInteraktion(event) {
    const form = event.target && event.target.closest ? event.target.closest('form') : null;
    if (form) interagiert.add(form);
  }

  for (let i = 0; i < EREIGNISSE.length; i++) {
    document.addEventListener(EREIGNISSE[i], merkeInteraktion, { capture: true, passive: true });
  }

  function istNewsletterFormular(form) {
    if (!form || form.tagName !== 'FORM') return false;
    // Nur Formulare mit Koeder. Damit bleibt der Warenkorb, die Suche und jedes
    // andere Formular unangetastet, und ein Formular ohne Koeder wird nicht
    // versehentlich blockiert.
    return !!form.querySelector(KOEDER);
  }

  function verdacht(form) {
    const koeder = form.querySelector(KOEDER);
    if (koeder && koeder.value.trim() !== '') return 'koeder';
    if (!interagiert.has(form)) return 'keine-interaktion';
    return null;
  }

  function zeigeMeldung(form) {
    const meldung = form.querySelector(MELDUNG);
    if (!meldung) return;
    meldung.hidden = false;
    const feld = form.querySelector('[name="contact[email]"]');
    if (feld) {
      if (meldung.id) feld.setAttribute('aria-describedby', meldung.id);
      feld.focus();
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!istNewsletterFormular(form)) return;

      const meldung = form.querySelector(MELDUNG);
      // Alte Meldung erst weg, sonst bleibt sie nach einem geglueckten zweiten
      // Versuch neben der Erfolgsmeldung stehen.
      if (meldung) meldung.hidden = true;

      if (!verdacht(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      zeigeMeldung(form);
    },
    { capture: true },
  );
})();
